import { SdkContext } from '../internal'
import type { PointsSettings, PointsStart, PointsStatement, RedeemResult } from '@/types/points'

/** F-160: the points balance and redeeming in the Store. Paths written by hand (F-03). */
export class PointsResource {
  constructor(private ctx: SdkContext) {}

  /** Owner and admin. */
  async getSettings(): Promise<PointsSettings> {
    return this.ctx.call({ httpMethod: 'GET', path: '/points/settings' })
  }

  /** Owner and admin. `start` only counts the first time it is switched on. */
  async updateSettings(body: { enabled?: boolean; start?: PointsStart; currencyName?: string | null }): Promise<PointsSettings> {
    return this.ctx.call({ httpMethod: 'PUT', path: '/points/settings', hasBody: true }, { body })
  }

  /** The viewer's own balance and statement, newest first. */
  async me(params: { limit?: number; before?: string } = {}): Promise<PointsStatement> {
    return this.ctx.call({ httpMethod: 'GET', path: '/points/me' }, { query: Object.fromEntries(Object.entries(params).filter(([, v]) => v)) })
  }

  /** Owner and admin, of any member. */
  async ofMember(memberId: string, params: { limit?: number; before?: string } = {}): Promise<PointsStatement> {
    return this.ctx.call(
      { httpMethod: 'GET', path: '/points/members/{memberId}' },
      { memberId, query: Object.fromEntries(Object.entries(params).filter(([, v]) => v)) }
    )
  }

  /**
   * One unit for points. The same `idempotencyKey` answers the same purchase without spending again,
   * so the screen keeps one key per attempt and only renews it after a definite answer.
   */
  async redeem(productId: string, idempotencyKey: string, shippingAddress?: Record<string, unknown>): Promise<RedeemResult> {
    return this.ctx.call(
      { httpMethod: 'POST', path: '/storefront/products/{productId}/redeem', hasBody: true },
      { productId, headers: { 'Idempotency-Key': idempotencyKey }, body: shippingAddress ? { shippingAddress } : {} }
    )
  }
}
